import type { NegativeNews, NegativeNewsRiskLevel } from '@gcv/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { NegativeNewsApi } from 'api';
import { updateNegativeNewsCache } from 'tanstack-hooks/fi-negative-news/negative-news-cache';
import { NEGATIVE_NEWS_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useSetNegativeNewsRiskLevel(negativeNewsRecord: NegativeNews) {
  const { user } = useUser();
  const negativeNewsApi = new NegativeNewsApi();
  const queryClient = useQueryClient();

  const { mutate: setNegativeNewsRiskLevel } = useMutation({
    mutationKey: [NEGATIVE_NEWS_KEY],
    mutationFn: (riskLevel: NegativeNewsRiskLevel) =>
      negativeNewsApi.setRiskLevel(
        negativeNewsRecord.source_story_id,
        negativeNewsRecord.sp_id,
        negativeNewsRecord.crb_id,
        riskLevel
      ),
    onSuccess: (_data, riskLevel) => {
      updateNegativeNewsCache(queryClient, negativeNewsRecord, {
        risk_level: riskLevel,
        risk_level_last_upated: new Date().toISOString(),
        risk_level_last_upated_by: user?.id
      });
    },
    meta: {
      snackbarErrorMessage:
        'There was an issue updating the risk level. Please contact support if the problem persists.'
    }
  });

  return { setNegativeNewsRiskLevel };
}
